import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import BpmnViewer from 'bpmn-js';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import { queryFlowByProcInsId, readXml } from '@/services/flow';
export default {
  name: 'ProcessTracker',
  props: {
    processInstanceId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      bpmnViewer: null,
      loading: false,
      errorMsg: '',
      finished: false,
      procInsInfo: null,
      currentActivityIds: [],
      currentActivityNames: [],
      completedActivityIds: [],
      assigneeMap: {},
      bpmnXml: '',
      dragCleanup: null
    };
  },
  watch: {
    processInstanceId: {
      immediate: true,
      handler: function handler(newId) {
        if (newId) this.loadTracker();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyViewer();
  },
  methods: {
    loadTracker: function loadTracker() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _data$flowList$, res, data, procDefId, flowList, activeFlows, completedFlows, xmlRes, xmlpamrs, objpamrs, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (_this.processInstanceId) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this.destroyViewer();
              _this.loading = true;
              _this.errorMsg = '';
              _context.p = 2;
              _context.n = 3;
              return queryFlowByProcInsId(_this.processInstanceId);
            case 3:
              res = _context.v;
              if (!(res.data.code !== 200)) {
                _context.n = 4;
                break;
              }
              throw new Error('获取流程记录失败');
            case 4:
              data = res.data.data;
              _this.procInsInfo = {
                id: data.procInsId,
                name: data.procInsName
              };
              procDefId = data.procDefId || data.flowList && ((_data$flowList$ = data.flowList[0]) === null || _data$flowList$ === void 0 ? void 0 : _data$flowList$.procDefId);
              if (procDefId) {
                _context.n = 5;
                break;
              }
              throw new Error('未找到流程定义ID');
            case 5:
              _this.finished = data.endTime != null || data.fillStatus === 3;
              flowList = data.flowList || [];
              activeFlows = flowList.filter(function (item) {
                return !item.finishTime;
              });
              completedFlows = flowList.filter(function (item) {
                return item.finishTime;
              });
              _this.currentActivityIds = activeFlows.map(function (item) {
                return item.taskDefKey;
              }).filter(function (id) {
                return id;
              });
              _this.currentActivityNames = activeFlows.map(function (item) {
                return item.taskName;
              }).filter(function (name) {
                return name;
              });
              _this.completedActivityIds = completedFlows.map(function (item) {
                return item.taskDefKey;
              }).filter(function (id) {
                return id;
              });
              _this.assigneeMap = {};
              flowList.forEach(function (item) {
                var key = item.taskDefKey;
                if (key) {
                  var assigneeName = item.assigneeName || item.assignee || '';
                  var deptName = item.deptName || '';
                  _this.assigneeMap[key] = {
                    assigneeName: assigneeName,
                    deptName: deptName
                  };
                }
              });
              _context.n = 6;
              return readXml(procDefId);
            case 6:
              xmlRes = _context.v;
              if (!(xmlRes.data.code !== 200)) {
                _context.n = 7;
                break;
              }
              throw new Error('获取流程图定义失败');
            case 7:
              xmlpamrs = xmlRes.data.message;
              if (xmlpamrs) {
                objpamrs = JSON.parse(xmlpamrs);
                if (objpamrs) _this.bpmnXml = objpamrs.data;
              }
              _context.n = 8;
              return _this.initViewer();
            case 8:
              _this.highlightNodes();
              _this.addAssigneeTooltips();
              _this.enableCanvasDrag(); // 启用拖拽
              _this.resetZoom();
              _context.n = 10;
              break;
            case 9:
              _context.p = 9;
              _t = _context.v;
              _this.errorMsg = _t.message || '加载流程图失败';
            case 10:
              _context.p = 10;
              _this.loading = false;
              return _context.f(10);
            case 11:
              return _context.a(2);
          }
        }, _callee, null, [[2, 9, 10, 11]]);
      }))();
    },
    initViewer: function initViewer() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (!_this2.$refs.canvasRef) reject(new Error('画布容器未找到'));
        _this2.bpmnViewer = new BpmnViewer({
          container: _this2.$refs.canvasRef
        });
        _this2.bpmnViewer.importXML(_this2.bpmnXml, function (err) {
          if (err) reject(new Error('BPMN渲染失败: ' + err.message));else resolve();
        });
      });
    },
    destroyViewer: function destroyViewer() {
      if (this.dragCleanup) {
        this.dragCleanup();
        this.dragCleanup = null;
      }
      if (this.bpmnViewer) {
        try {
          this.bpmnViewer.destroy();
        } catch (e) {}
        this.bpmnViewer = null;
      }
    },
    clearHighlights: function clearHighlights() {
      if (!this.bpmnViewer) return;
      var elementRegistry = this.bpmnViewer.get('elementRegistry');
      elementRegistry.forEach(function (el) {
        var gfx = elementRegistry.getGraphics(el.id);
        if (gfx && gfx.classList) {
          gfx.classList.remove('highlight-activity');
          gfx.classList.remove('completed-activity');
        }
      });
    },
    highlightNodes: function highlightNodes() {
      if (!this.bpmnViewer) return;
      this.clearHighlights();
      var elementRegistry = this.bpmnViewer.get('elementRegistry');
      this.completedActivityIds.forEach(function (id) {
        var el = elementRegistry.get(id);
        if (el) {
          var gfx = elementRegistry.getGraphics(el.id);
          gfx.classList.add('completed-activity');
        }
      });
      this.currentActivityIds.forEach(function (id) {
        var el = elementRegistry.get(id);
        if (el) {
          var gfx = elementRegistry.getGraphics(el.id);
          gfx.classList.add('highlight-activity');
        }
      });
      var firstId = this.currentActivityIds[0];
      if (firstId) {
        var canvas = this.bpmnViewer.get('canvas');
        var el = elementRegistry.get(firstId);
        if (el) canvas.scrollToElement(el);
      }
    },
    addAssigneeTooltips: function addAssigneeTooltips() {
      var _this3 = this;
      if (!this.bpmnViewer) return;
      var overlays = this.bpmnViewer.get('overlays');
      var elementRegistry = this.bpmnViewer.get('elementRegistry');
      overlays.clear();
      Object.keys(this.assigneeMap).forEach(function (nodeId) {
        var element = elementRegistry.get(nodeId);
        if (!element) return;
        var _this3$assigneeMap$no = _this3.assigneeMap[nodeId],
          assigneeName = _this3$assigneeMap$no.assigneeName,
          deptName = _this3$assigneeMap$no.deptName;
        var overlayHtml = document.createElement('div');
        overlayHtml.className = 'assignee-overlay-multi';
        var htmlContent = "<div class=\"assignee-name\">\uD83D\uDC64 ".concat(assigneeName, "</div>");
        if (deptName) {
          htmlContent += "<div class=\"assignee-dept\">".concat(deptName, "</div>");
        }
        overlayHtml.innerHTML = htmlContent;
        overlays.add(nodeId, 'assignee-multi', {
          position: {
            bottom: -30,
            left: '50%',
            transform: 'translateX(-50%)'
          },
          html: overlayHtml
        });
      });
    },
    // 修复拖拽：使用 canvas.scroll 增量移动，无需 getScroll
    enableCanvasDrag: function enableCanvasDrag() {
      if (!this.bpmnViewer) return;
      var canvas = this.bpmnViewer.get('canvas');
      var container = this.$refs.canvasRef;
      if (!canvas || !container) return;
      var isDragging = false;
      var lastX, lastY;
      var onMouseDown = function onMouseDown(e) {
        if (e.button !== 0) return;
        isDragging = true;
        lastX = e.clientX;
        lastY = e.clientY;
        container.style.cursor = 'grabbing';
        e.preventDefault();
      };
      var onMouseMove = function onMouseMove(e) {
        if (!isDragging) return;
        var dx = e.clientX - lastX;
        var dy = e.clientY - lastY;
        if (dx !== 0 || dy !== 0) {
          canvas.scroll({
            dx: dx,
            dy: dy
          }); // 方向自然跟随鼠标
        }
        lastX = e.clientX;
        lastY = e.clientY;
      };
      var onMouseUp = function onMouseUp() {
        isDragging = false;
        container.style.cursor = '';
      };
      container.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
      this.dragCleanup = function () {
        container.removeEventListener('mousedown', onMouseDown);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        container.style.cursor = '';
      };
    },
    zoomIn: function zoomIn() {
      if (this.bpmnViewer) this.bpmnViewer.get('canvas').zoom(this.bpmnViewer.get('canvas').zoom() * 1.2);
    },
    zoomOut: function zoomOut() {
      if (this.bpmnViewer) this.bpmnViewer.get('canvas').zoom(this.bpmnViewer.get('canvas').zoom() / 1.2);
    },
    resetZoom: function resetZoom() {
      if (this.bpmnViewer) this.bpmnViewer.get('canvas').zoom('fit-viewport');
    },
    refresh: function refresh() {
      this.loadTracker();
    }
  }
};